import {createSlice} from "@reduxjs/toolkit";

const initialGameListState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  gameList: [],
  usersCount: null,
  allgameslist: null, 
  editGame: [],
  deleteGame: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const GameListSlice = createSlice({
  
  name: "gameList",
  initialState: initialGameListState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    // getstaffUserById
    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice",totalCount, entities)
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    AppFlyerTokenExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    GamesList: (state, action) => {
      const { allgameslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.allgameslist = allgameslist;
    },
    updateGame: (state, action) => {
      const { editGame } = action.payload;
      state.error = null;
      state.editGame = editGame;
    },
    deleteGame: (state, action) => {
      const { deleteGame } = action.payload;
      state.error = null;
      state.deleteGame = deleteGame;
    },
    editGame: (state, action) => {
      const { editGame } = action.payload;
      state.error = null;
      state.editGame = editGame;
    },
    loginUserFetchedCompany: (state, action) => {
      state.actionsLoading = false;
      state.loginUserCompany = action.payload.loginUserCompany;
      state.error = null;
  },
  }
});
